import { cloneElement } from 'react';

import type { TextFieldProps } from '@mui/material';
import type { FC } from 'react';
import type { ControllerProps } from 'react-hook-form';

export interface MuiTextFieldNumberAdapterProps
  extends Omit<TextFieldProps, 'children'>, Partial<Parameters<ControllerProps['render']>[0]>
{
  children: React.ReactElement<TextFieldProps>;
  isExposingTextField?: boolean;
}

export const MuiTextFieldNumberAdapter: FC<MuiTextFieldNumberAdapterProps> = ({
  children,
  field,
  fieldState,
  formState,
  isExposingTextField = true,
  helperText = isExposingTextField && ' ',
  ...props
}) =>
  cloneElement<TextFieldProps>( children, {
    ...field,
    value: field?.value ?? '',
    onChange: (event) => field?.onChange( +event.target.value ),
    ...props,
    error: Boolean( fieldState?.error ),
    helperText: fieldState?.error?.message ?? helperText,
  } );
